export const menuToggleVariants = [
  { variants: { closed: { d: 'M1 11 L35 11' }, open: { d: 'M8 28 L28 8' } } },
  {
    d: 'M1 18 L35 18',
    variants: { closed: { opacity: 1 }, open: { opacity: 0 } },
    transition: { duration: 0.1 },
  },
  { variants: { closed: { d: 'M1 25 L35 25' }, open: { d: 'M8 8 L28 28' } } },
];
